import React from 'react'
import PropTypes from 'prop-types'
import useTheme from './hooks/use-theme'
import { observer } from 'mobx-react'
import { TabsField } from 'support/fields'

function TabbedThemeSwitcher (props) {
  const theme = useTheme()

  return (
    <TabsField
      enum={props.enum}
      options={props.options}
      onChange={option => theme.set(option)}
      defaultValue={theme.get()}
    />
  )
}

export default observer(TabbedThemeSwitcher)

TabbedThemeSwitcher.defaultProps = {
  enum: null,
  options: []
}

TabbedThemeSwitcher.propTypes = {
  enum: PropTypes.string,
  options: PropTypes.array
}
